const USER_INFO_KEY = "userInfo";
const USER_PERMISSIONS_KEY = "user-permissions";
const IS_AUTHENTICATED_KEY = "isAuthenticated";

export function setStoredUserInfo(data: unknown) {
  const value = JSON.stringify(data);
  sessionStorage.setItem(USER_INFO_KEY, value);
  localStorage.setItem(USER_INFO_KEY, value);
}

export function setStoredUserPermissions(data: unknown) {
  const value = JSON.stringify(data);
  sessionStorage.setItem(USER_PERMISSIONS_KEY, value);
  localStorage.setItem(USER_PERMISSIONS_KEY, value);
}

/**
 * Ensures this tab's sessionStorage has auth data for existing readers.
 * Copies from localStorage when sessionStorage is empty (e.g. new tab),
 * and backfills localStorage when only sessionStorage has data (pre-migration).
 * Returns true when userInfo is available.
 */
export function ensureSessionAuthFromLocal(): boolean {
  let userInfo = sessionStorage.getItem(USER_INFO_KEY);
  const localUserInfo = localStorage.getItem(USER_INFO_KEY);

  if (!userInfo && localUserInfo) {
    sessionStorage.setItem(USER_INFO_KEY, localUserInfo);
    userInfo = localUserInfo;
  } else if (userInfo && !localUserInfo) {
    localStorage.setItem(USER_INFO_KEY, userInfo);
  }

  const sessionPermissions = sessionStorage.getItem(USER_PERMISSIONS_KEY);
  const localPermissions = localStorage.getItem(USER_PERMISSIONS_KEY);

  if (!sessionPermissions && localPermissions) {
    sessionStorage.setItem(USER_PERMISSIONS_KEY, localPermissions);
  } else if (sessionPermissions && !localPermissions) {
    localStorage.setItem(USER_PERMISSIONS_KEY, sessionPermissions);
  }

  return !!userInfo;
}

export function clearAuthStorage() {
  sessionStorage.removeItem(USER_INFO_KEY);
  sessionStorage.removeItem(USER_PERMISSIONS_KEY);
  localStorage.removeItem(USER_INFO_KEY);
  localStorage.removeItem(USER_PERMISSIONS_KEY);
  localStorage.removeItem(IS_AUTHENTICATED_KEY);
}
